<template>
    <website-page>
        <digital-signage-navigation></digital-signage-navigation>

        <div class="main-section overlay">
            <b-container>
                <b-img width="128" class="mb-3" fluid :src="require('../../assets/img/applications/storyboard-infinite.png')"
                alt="Eye-Infinite Storyboard HTML5 creation tool"></b-img>
                <br>
                <h1 class="blured">
                    Eye-Infinite Storyboard
                </h1>
                <br>
                <h2 class="subtitle blured" v-tr>
                    Download Center - Get the latest version of the software|Centre de téléchargement - Obtenez la dernière version du logiciel
                </h2>

                <div class="text-center">
                    <b-btn variant="light" target="_blank" class="mr-2"
                           href="https://eyeinlivestorage.blob.core.windows.net/public/software/infinite-storyboard/eye_infinite_storyboard_win_4.10.exe">
                        <b-img class="iconSvg mr-1" height="15" :src="require('../../assets/img/font-awesome/windows-brands.svg')"></b-img>
                        <span v-tr>Download for Windows|Télécharger pour Windows</span>
                    </b-btn>
                    <b-btn variant="light" target="_blank"
                           href="https://eyeinlivestorage.blob.core.windows.net/public/software/infinite-storyboard/eye_infinite_storyboard_mac_4.10.dmg">
                        <b-img class="iconSvg mr-1" height="15" :src="require('../../assets/img/font-awesome/apple-brands.svg')"></b-img>
                        <span v-tr>Download for MacOS|Télécharger pour MacOS</span>
                    </b-btn>
                </div>

                <div class="mt-5 small text-light">
                    <span v-tr>By downloading and using the software, you agree to the |En téléchargeant et en utilisant le logiciel, vous acceptez les </span>
                    <a class="text-underline text-light" v-if="isFrench()" href="https://eyeinlivestorage.blob.core.windows.net/public/software/storyboard-termes-et-conditions.pdf" target="_blank">Termes et conditions d'utilisation</a>
                    <a class="text-underline text-light" v-else href="https://eyeinlivestorage.blob.core.windows.net/public/software/storyboard-terms-conditions.pdf" target="_blank">Terms and conditions of use</a>
                </div>
                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#download'" variant="outline-light"><span v-tr>Other versions|Autres versions</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="download" class="page">
            <b-container class="text-center">
                <h3 class="mb-4" v-tr>
                    Other Version|Autres version
                </h3>

                <b-row>
                    <b-col>
                        <b-img width="145" class="m-3" fluid :src="require('../../assets/img/applications/storyboard-pro.png')"
                               alt="Eye-In Storyboard Pro"></b-img>

                        <h5 class="mb-4">
                            Eye-In Storyboard Pro
                        </h5>
                        <p class="f-500">For advanced users only</p>
                        <b-btn variant="light" target="_blank" class="mr-2"
                               href="https://eyeinlivestorage.blob.core.windows.net/public/software/storyboard-pro/storyboard_pro_win_7.09.exe">
                            <b-img class="iconSvg mr-1" height="15" :src="require('../../assets/img/font-awesome/windows-brands.svg')"></b-img>
                            <span v-tr>Download for Windows|Télécharger pour Windows</span>
                        </b-btn>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import DigitalSignageNavigation from "@/navigation/digital-signage-navigation.vue";
    import {isFrench, translate} from "../../../vue-components/helpers/i18n.js";

    export default {
        name: `storyboard-others`,
        components: {DigitalSignageNavigation},
        metaInfo: {
            title: translate(`Eye-Infinite Storyboard HTML5 Design Tool for Digital Signage|Outil de conception HTML5 Eye-Infinite Storyboard pour l'affichage numérique`),
            meta: [
                { name: `keywords`, content: `eye-in, storyboard, infinite, pro, lite, html5, design, content creation, powerful template, library` },
                { name: `description`, content: translate(`Download the latest version of Eye-Infinite Storyboard, and create amazing Digital Signage content|Téléchargez la dernière version de Eye-Infinite Storyboard et créez du contenu d'affichage numérique incroyable`) }
            ]
        },
        data() {
            return {
                isFrench: isFrench
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        background-image: url('../../assets/img/backgrounds/abstract.jpg');
        background-image: url('../../assets/img/backgrounds/abstract.webp');
        background-size: cover;
        background-position: center bottom;
    }
</style>
